module.exports = __webpack_public_path__ + "img/ru.02989ed6.svg";